import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热议榜单</h2>
          <p className="text-sm text-foreground-600 mt-3">全网热搜实时排行，热度一目了然</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => (
              <a
                key={item.rank}
                href="#cards"
                className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-50 transition-colors cursor-pointer ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <span
                  className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                        ? 'bg-primary-500 text-background-50'
                        : item.rank === 3
                          ? 'bg-secondary-500 text-background-50'
                          : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                  <i
                    className={`text-xs ${
                      item.change === 'up'
                        ? 'ri-arrow-up-line text-accent-500'
                        : item.change === 'down'
                          ? 'ri-arrow-down-line text-foreground-400'
                          : 'ri-add-circle-line text-primary-500'
                    }`}
                  ></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}